import WebsiteModel                    from '@models/website/WebsiteModel';
import WebsiteEntertainmentStatusModel from '@models/website/WebsiteEntertainmentStatusModel';
import doc                             from '@widesk-core/decorators/doc';
import WebsiteServiceModel             from '@/models/WebsiteServiceModel';
import Blamable                        from '@/models/traits/Blamable';
import { Addable }                     from '@widesk-core/decorators/addable';
import { Editable }                    from '@widesk-core/decorators/editable';
import { Deletable }                   from '@widesk-core/decorators/deletable';
import { Timestampable }               from '@widesk-core/decorators/timestampable';

@doc.path('/website_entertainments/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
abstract class AbstractWebsiteEntertainmentModel extends Blamable(
	WebsiteServiceModel,
) {
	declare protected _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'tags[serviceUrn][tagReference]': id;
		'website.showUrn': Urn;
		'entertainmentUrn': Urn;
		'website': id;
		'websiteEntertainmentStatus': string;
		'search': string;
	};

	declare private _tsSorts: {
		id: string;
		entertainmentUrn: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.model(WebsiteModel) declare website: WebsiteModel;
	declare abstract entertainment: unknown;
	@doc.string declare label: string;
	@doc.string declare slugPrefix: string;
	@doc.string declare location: string;
	@doc.model(WebsiteEntertainmentStatusModel)
	declare websiteEntertainmentStatus: WebsiteEntertainmentStatusModel;
}

interface AbstractWebsiteEntertainmentModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable {}

export default AbstractWebsiteEntertainmentModel;
